<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">RESULT FRAMEWORK</span>
                <span v-else>RESULT FRAMEWORK</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Result Framework</span>
                    <span v-else>Result Framework</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid blog py-2" style="display: none;">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    INFOGRAFIS RESULT FRAMEWORK
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    RESULT FRAMEWORK INFOGRAPHICS
                </h1>
            </div>
            <div class="row">
                <div class="col-sm-3 text-center"></div>
                <div class="col-sm-6 text-center">
                    <label v-if="(bahasa === null) || (bahasa == 'ina')">
                        Pilihan Result Framework
                    </label>
                    <label v-else>
                        Choice of Result Frameworks
                    </label>
                    <v-select :options="kpi" :reduce="(label) => label.code" label="label" v-model="defaultSelectedkpi"
                        @update:modelValue="onkpiChange"
                        style="background-color: #ffffff;color: black;z-index: 9999;"></v-select>
                </div>
                <div class="col-sm-3 text-center"></div>
            </div>

        </div>
        <div class="container py-2">
            <div class="col-lg-12 text-center">
                <LineGrafik height="450" :options="chartOptions" :series="series" style="z-index: 1;">
                </LineGrafik>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    KERANGKA HASIL KEMAJUAN
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    RESULT FRAMEWORK PROGRESS
                </h1>
            </div>
        </div>
        <div class="container py-2">
            <div class="col-sm-12 text-center">
                <a class="hitam">
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.."
                        @click="G_tableCSVTabel3('_PROGRESRESULTFRAMEWORK_')">
                        <i class="fas fa-download"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data .xlsx
                        </span>
                        <span v-else>
                            Download Data .xlsx
                        </span>
                    </button>
                </a>
            </div>
            <div class="col-sm-12 text-center">&nbsp;</div>
            <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldataprogres" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 150px;" rowspan="2">Target<br>Indicator</th>
                                <th style="width: 100px;" rowspan="2">Baseline<br>Value<br>(2023)</th>
                                <th style="width: 100px;" rowspan="2">End<br>Target<br>Value</th>
                                <th style="width: 150px;" rowspan="2">Source<br>(baseline/target)
                                </th>
                                <th style="width: 100px;" rowspan="2">Responsibility</th>
                                <th style="width: 150px;" rowspan="2">Progress</th>
                                <th style="width: 150px;" rowspan="2">Remarks</th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in datamaster3" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td :colspan="datalist.colspan" :class="datalist.class"
                                        v-if="datalist.level == 'Outcome' || datalist.level == 'Output' || datalist.level == 'Komponen' || datalist.level == 'Rincian'">
                                        <span v-html="datalist.nama"></span>
                                    </td>
                                    <td :colspan="datalist.colspan" :class="datalist.class"
                                        v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen' && datalist.level != 'Rincian'">
                                        <span v-html="datalist.nama"></span>
                                    </td>
                                    <td :colspan="datalist.colspan" class="text-center" :class="datalist.class"
                                        v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                        <span v-html="datalist.baseline"></span> <span v-html="datalist.satuan"></span>
                                    </td>
                                    <td :colspan="datalist.colspan" class="text-center" :class="datalist.class"
                                        v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                        <span v-html="datalist.target"></span> <span
                                            v-html="datalist.satuan_target"></span>
                                    </td>
                                    <td :colspan="datalist.colspan"
                                        v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                        <span v-html="datalist.source_indikator"></span>
                                    </td>
                                    <td :colspan="datalist.colspan" class="text-center" :class="datalist.class"
                                        v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                        <span v-html="datalist.responsibility"></span>
                                    </td>
                                    <td :colspan="datalist.colspan" :class="datalist.class"
                                        v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                        <span v-html="datalist.progress"></span>
                                    </td>
                                    <td :colspan="datalist.colspan" :class="datalist.class"
                                        v-if="datalist.level != 'Outcome' && datalist.level != 'Output' && datalist.level != 'Komponen'">
                                        <span v-html="datalist.remarks"></span>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                <td colspan="7">Data masih kosong</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, vSelect, LineGrafik: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datamaster2: [],
            datamaster3: [],
            kpimaster: [],
            carikata: '',
            colspan: 0,
            colspan2: 0,
            datatahun: [],
            ekportexcel: [],
            ekportexcel1: [],
            ekportexcel2: [],

            id_user2: [],
            dataid_user2: [],
            defaultSelectedid_user2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user2: '',

            lokasi2: [],
            datalokasi2: [],
            defaultSelectedlokasi2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi2: '',

            jenispekerjaan2: [],
            datajenispekerjaan2: [],
            defaultSelectedjenispekerjaan2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedjenispekerjaan2: '',

            tahunmulai2: [],
            datatahunmulai2: [],
            defaultSelectedtahunmulai2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunmulai2: '',


            kpi: [],
            datakpi: [],
            defaultSelectedkpi: {
                code: 0,
                label: 'Semua Result Framework',
                tag: '',
            },
            selectedkpi: '',

            komponen: [],
            datakomponen: [],
            defaultSelectedkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedkomponen: '',

            subkomponen: [],
            datasubkomponen: [],
            defaultSelectedsubkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedsubkomponen: '',

            showColumnTahun: true,
            showColumnPelaksana: true,
            showColumnLokasi: true,
            showColumnKegiatan: true,
            showColumnJenis: true,
            showColumnKomponen: true,
            showColumnSubKomponen: true,
            series: [],

            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    toolbar: {
                        show: true
                    }
                },
                colors: ['#77B6EA', '#ADFF2F'],
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        if (isNaN(val)) {
                            return '';
                        }
                        else {
                            return val.toFixed(2).toString().replaceAll(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        }
                    },
                    offsetY: -5,
                    style: {
                        fontSize: '8px',
                        colors: ['#5c6165', '#ff7f00'],
                    }
                },
                stroke: {
                    curve: 'smooth'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    title: {
                        text: 'Tahun'
                    }
                },
                yaxis: {
                    title: {
                        text: 'Nilai Result Framework'
                    },
                    labels: {
                        formatter: function (value) {
                            return value.toFixed(2).toString().replaceAll(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        }
                    },
                },
                legend: {
                    position: 'bottom',
                    show: true,
                }
            },

            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata'), { sheet: "Rekap Result Framework" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata2'), { sheet: "Detail Result Framework" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        async G_tableCSVTabel3(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakpdo-Data?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        onid_user2Change(a) {
            try {
                this.selectedid_user2 = this.id_user2[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        ontahunmulai2Change(a) {
            try {
                this.selectedtahunmulai2 = this.tahunmulai2[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onlokasi2Change(a) {
            try {
                this.selectedlokasi2 = this.lokasi2[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi2);
            this.ambildata();
        },
        onjenispekerjaan2Change(a) {
            try {
                this.selectedjenispekerjaan2 = this.jenispekerjaan2[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan2)
            this.ambildata();

            //alert(this.selectedjenispekerjaan2);
        },
        onkpiChange(a) {
            try {
                this.selectedkpi = this.kpi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedkpi)
            this.rubahdatagrafik();

            //alert(this.selectedkpi);
        },
        onkomponenChange(a) {
            try {
                this.selectedkomponen = this.komponen[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedkomponen)
            this.getsubkomponen();

            //alert(this.selectedkomponen);
        },
        onsubkomponenChange(a) {
            try {
                this.selectedsubkomponen = this.subkomponen[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
            //alert(this.selectedsubkomponen)
            //this.rubahdatagrafik();

            //alert(this.selectedsubkomponen);
        },
        async rubahdatagrafik() {
            this.halamanloading = true;
            this.series = [];
            for (let i = 0; i < this.datamaster.length; i++) {
                for (let x = 0; x < this.datamaster[i].Detail.length; x++) {
                    var detaildatatarget = [];
                    var detaildatacapaian = [];

                    for (let c = 0; c < this.datamaster[i].Detail[x].detaildata.length; c++) {
                        var target = this.datamaster[i].Detail[x].detaildata[c].target;
                        if (target == 'Ya / Yes') {
                            target = 100;
                        }
                        if (target == 'Tidak / No') {
                            target = 0;
                        }
                        var capaian = this.datamaster[i].Detail[x].detaildata[c].capaian;
                        if (capaian == 'Ya / Yes') {
                            capaian = 100;
                        }
                        else if (capaian == 'Tidak / No') {
                            capaian = 0;
                        }
                        else {
                            if (c == 0) {
                                capaian = capaian;
                            }
                            else {
                                capaian = capaian;
                                //capaian = parseInt(capaian) + parseInt(detaildatacapaian[c - 1]);
                            }
                        }
                        if (target == 'NaN') {
                            target = 0;
                        }
                        detaildatatarget.push(target);
                        if (capaian == 'NaN') {
                            capaian = null;
                        }
                        if (capaian != 'NaN') {
                            detaildatacapaian.push(capaian);
                        }


                        //alert(detaildatacapaian[detaildatacapaian.length-1]);
                    }
                    //alert(detaildatacapaian);
                    if (this.selectedkpi != '') {
                        if (this.selectedkpi == this.datamaster[i].Detail[x].indikator_no) {
                            this.series.push({
                                name: 'Target Result Framework - ' + this.datamaster[i].Detail[x].indikator_no,
                                data: detaildatatarget,
                            });
                            this.series.push({
                                name: 'Capaian Result Framework - ' + this.datamaster[i].Detail[x].indikator_no,
                                data: detaildatacapaian,
                            });
                        }
                    }
                    else {
                        this.series.push({
                            name: 'Target Result Framework - ' + this.datamaster[i].Detail[x].indikator_no,
                            data: detaildatatarget,
                        });
                        this.series.push({
                            name: 'Capaian Result Framework - ' + this.datamaster[i].Detail[x].indikator_no,
                            data: detaildatacapaian,
                        });
                    }

                }
            }
            //alert(detaildatacapaian);
            this.halamanloading = false;
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationreffmonitoring-UserProject?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user2 = [];
                        this.id_user2 = [];
                        this.dataid_user2 = Response.data.content.data;
                        this.dataid_user2.forEach((item) => {
                            this.id_user2.push({
                                label: item.nama_satker,
                                code: this.dataid_user2.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedid_user2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.id_user2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedid_user2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.id_user2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi2 = [];
                        this.lokasi2 = [];
                        this.datalokasi2 = Response.data.content.data;
                        this.datalokasi2.forEach((item) => {
                            this.lokasi2.push({
                                label: item.nama,
                                code: this.datalokasi2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedlokasi2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.lokasi2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedlokasi2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.lokasi2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-JenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan2 = [];
                        this.jenispekerjaan2 = [];
                        this.datajenispekerjaan2 = Response.data.content.data;
                        this.datajenispekerjaan2.forEach((item) => {
                            this.jenispekerjaan2.push({
                                label: item.nama,
                                code: this.datajenispekerjaan2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedjenispekerjaan2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.jenispekerjaan2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedjenispekerjaan2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.jenispekerjaan2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-TahunProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahunmulai2 = [];
                        this.tahunmulai2 = [];
                        this.datatahunmulai2 = Response.data.content.data;
                        this.datatahunmulai2.forEach((item) => {
                            this.tahunmulai2.push({
                                label: item.tahun,
                                code: this.datatahunmulai2.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunmulai2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunmulai2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunmulai2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunmulai2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationKomponen-GetProyekKomponen?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datakomponen = [];
                        this.komponen = [];
                        this.datakomponen = Response.data.content.data;
                        this.datakomponen.forEach((item) => {
                            this.komponen.push({
                                label: item.nama,
                                code: this.datakomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.komponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.komponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    else {
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async getsubkomponen() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    else {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedsubkomponen = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.subkomponen.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            this.ambildata();
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            this.halamanloading = true;

            await mainAPI.get("parastapainnovationmonitoring-RESULTFRAMEWORKPROGRESS?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster3 = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.halamanloading = true;
                        this.datapesan = '';
                        this.datamaster3 = Response.data.content.data;
                        //alert(JSON.stringify(this.datamaster3));
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.datamaster3 = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster3 = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildatareff();
        this.ambildata();
    },
}
</script>

<style></style>